import { type IWarehouseLine } from './types'

export const warehouseLineInputs = (form: Partial<IWarehouseLine>): Record<string, any> => ({
  name: { inputType: 'text', title: 'Warehouse Line', value: form.name, required: true },
  bank: { inputType: 'text', title: 'Bank', value: form.bank },
  glAccountNo: { inputType: 'text', title: 'GL Acct', value: form.glAccountNo },
  commitment: { inputType: 'text', type: 'number', title: 'Commitment', value: form.commitment },
  advanceRate: { inputType: 'text', type: 'number', title: 'Adv. Rate (%)', value: form.advanceRate },
})
